import { createVNode as _createVNode } from "vue";
/**
 * @author liaoyanhua
 * @fileoverview 赛事奖励 - pc
 */

import { defineComponent, reactive, computed } from 'vue';
// components
import SwiperBox from "@/components/pc/common/swiper-box.vue";
import SelectBtn from "@/components/pc/common/select-btns.vue";
// config
import { groupList, wjAwardListPC, zhAwardListPC, ywAwardListPC } from '@/config/information';
// assets
import scAwardTitleUrl from "@/assets/img/pc/sc-award-title.png";
import _ from "lodash";
const awardAllList = [wjAwardListPC, zhAwardListPC, ywAwardListPC];
export default defineComponent({
  name: 'RaceAwards',
  setup() {
    const state = reactive({
      groupActive: 1
    });
    const topThree = computed(() => {
      return awardAllList[state.groupActive - 1].three.slideList;
    });
    return () => {
      return _createVNode("div", {
        "class": "pc-explain pc-information"
      }, [_createVNode("div", {
        "class": "sc-award",
        "id": "sc-award"
      }, [_createVNode("img", {
        "id": "award",
        "class": "title",
        "src": scAwardTitleUrl
      }, null), _createVNode("div", {
        "class": "award-content"
      }, [_createVNode("div", {
        "class": "operate-box"
      }, [_createVNode(SelectBtn, {
        "onClick": val => {
          state.groupActive = val.value;
        },
        "dataValue": state.groupActive,
        "style": {
          width: "200px"
        },
        "options": groupList,
        "defaultOption": groupList[0]
      }, null)]), _createVNode("div", {
        "class": "top-3"
      }, [_.map(topThree.value, (item, index) => {
        return _createVNode("div", {
          "class": ["top-box", index !== 1 ? "top-other" : ""]
        }, [_createVNode("img", {
          "src": require(`@/assets/img/pc/${item}`)
        }, null)]);
      })])]), _createVNode("div", {
        "class": "swiper-box"
      }, [_createVNode(SwiperBox, {
        "swiperSetInfo": awardAllList[state.groupActive - 1].other
      }, null)])])]);
    };
  }
});